import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-energy/15 bg-navy-light py-16 sm:py-20" aria-labelledby="system-title" data-id="element-181" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-182" data-mp="36lwiqwboajmn">
        <span className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-cream" data-id="element-183" data-mp="31lqxpyzwrvdj">
          <AwardIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-184" data-mp="2ss5heb83i620" /> Il sistema didattico più completo di Energie Rinnovabili per docenti
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-185" data-mp="2nr7r1bcxm5pf">
          {productBrand} — <span className="text-gold" data-id="element-186" data-mp="2itprgbkt12u3">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-semibold text-haze" data-id="element-187" data-mp="2dw62ohqhd7nw">
          {totalVolumes} volumi · {totalBonuses} bonus esclusivi
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl border border-aqua/25 bg-navy-card p-6 text-left text-lg font-semibold leading-relaxed text-cream shadow-lg" data-id="element-188" data-mp="13xws757dp6wp">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-energy" aria-hidden="true" data-id="element-189" data-mp="u2v66i8egkyc" />
          Un sistema didattico completo per insegnare come si produce, si conserva e si usa l&apos;energia pulita: dai
          fondamenti dell&apos;energia al solare e all&apos;eolico, dall&apos;idroelettrico alla geotermia e alle biomasse,
          fino all&apos;accumulo, alle smart grid e alla didattica in classe. Con attività, esperimenti e verifiche pronti per
          la classe.
        </p>
      </div>
    </section>;
}